<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Reporte de Faltas Administrativas</h1>
      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area">
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import store from "@/store/index";
export default {
  data() {
    return {
      
    };
  },
  props: {},
  components: {
    
  },
  methods: {
    
  },
  mounted: function mounted() {
  },
  computed: {},
};
</script>

<style scoped>
span {
  font-weight: bold;
}
b {
  padding-right: 3px;
}

.new-row {
  margin-top: 20px;
}

.fas {
  cursor: pointer;
}
</style>





// WEBPACK FOOTER //
// src/components/SIFA/Reportes/ReporteDeFaltasAdministrativas/ReporteDeFaltasAdministrativas.vue